module.exports = __webpack_public_path__ + "img/reviews.55c9a777.jpg";